module.exports = __webpack_public_path__ + "static/media/error.78d97c0c.mp3";